import FormEventLocation from '@/components/FormEventLocation'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: FormEventLocation,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
